
import img1 from 'images/prof/img1.png'
import img2 from 'images/prof/img2.png'
import img3 from 'images/prof/img3.png'
import img4 from 'images/prof/img4.png'
import img5 from 'images/prof/img5.png'
import img6 from 'images/prof/img6.png'

export const PortfolioImg = [
    {
        id: 1,
        image: img1,
        category: "fashion"
        
    },
    {
        id: 2,
        image: img2,
        category: "fashion"
       
    },
    {
        id: 3,
        image: img5,
        category: "photography"
        
    },
    {
        id: 4,
        image: img4,
        category: "product"
        
    },
    {
        id: 5,
        image: img3,
        category: "Branding"
       
    },
    {
        id: 6,
        image: img6,
        category: "product"
        
    },
]